import { SidebarItem } from "@/layouts/types";

export function getExpandedItems(items: SidebarItem[], pathname: string): string[] {
  const expandedItems: string[] = [];

  function findExpandedItems(subItems: SidebarItem[], parentKey?: string) {
    for (const item of subItems) {
      if (item.subItems) {
        findExpandedItems(item.subItems, item.identifier);
      }
      if (item.link === pathname && parentKey) {
        expandedItems.push(parentKey);
      }
    }
  }

  findExpandedItems(items);

  return expandedItems;
}
